import { PaginationInput } from '../common/paginationInput';
import { ChannelFilter } from './channelFilter';

export class ChannelInput {
  paginationInput: PaginationInput = new PaginationInput(null, null);
  filter: ChannelFilter;
}
